import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/icons/search-icon.svg'
import _imports_1 from '../../../assets/images/profile-dashboard-image.png'
import _imports_2 from '../../../assets/images/sent_invite.png'


const _hoisted_1 = { class: "search_field tw-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-top-[35%] tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none -tw-translate-y-2/4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "tw-invert-[61%] tw-sepia-[6%] tw-saturate-[185%] tw-hue-rotate-[201deg] tw-brightness-[91%] tw-contrast-[90%]"
  })
], -1)
const _hoisted_3 = { class: "members_list tw-mt-6 tw-flex tw-gap-4 tw-flex-wrap tw-pb-6 tw-border-0 tw-border-b tw-border-dashed tw-border-[#C5D2F2] sm:tw-flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "member_img tw-w-[56px] tw-max-w-full tw-h-[56px] tw-rounded-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "tw-w-full tw-h-full tw-object-cover",
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "member_info tw-w-[calc(100%_-_86px)]" }
const _hoisted_6 = { class: "tw-text-xl tw-font-bold tw-text-[#0C0F4A] tw-leading-6 tw-mb-1 tw-break-words" }
const _hoisted_7 = { class: "tw-text-sm tw-font-bold tw-text-[#0C0F4A] tw-opacity-50 tw-leading-6" }
const _hoisted_8 = { class: "select_box tw-ml-auto tw-w-[30px]" }
const _hoisted_9 = { class: "member_footer tw-flex tw-justify-between tw-items-center sm:tw-flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", { class: "tw-mt-4 tw-text-sm tw-font-bold tw-text-[#0C0F4A] tw-tracking-[0.25px]" }, " Your invitations have been sent ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-2 tw-text-xs tw-font-bold tw-text-[#0c0f4a80] tw-tracking-[0.14px]" }, " We’ve sent your invitations to; ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!
  const _component_TeamMemberModal = _resolveComponent("TeamMemberModal")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_PropertyOwnerSubscriptionModal = _resolveComponent("PropertyOwnerSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowMainModal)
      ? (_openBlock(), _createBlock(_component_GeneralDialog, {
          key: 0,
          class: "invite_team_member_modal",
          headerTitle: "Select team member to invite to project",
          onOnClose: $setup.onCloseModal,
          maxWidth: "100%",
          width: "700px"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Search...",
                class: "tw-pl-10 tw-pr-4 tw-py-2 w-80 tw-border tw-bg-[#0c0f4a0a] tw-rounded-full tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500 tw-w-full tw-max-w-full",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchMember) = $event))
              }, null, 512), [
                [_vModelText, $setup.searchMember]
              ]),
              _hoisted_2
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterMemberList, (member, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "members_select tw-py-6 tw-px-4 tw-rounded-lg tw-shadow-[0px_0px_8px_0px_#0C0F4A14] tw-flex tw-gap-4 tw-items-center tw-w-[calc(50%_-_8px)] tw-max-w-full sm:tw-w-full",
                  key: index
                }, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h5", _hoisted_6, _toDisplayString(member?.email), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(member?.role), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_checkbox, {
                      value: member?.email,
                      modelValue: $setup.selectedMember,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedMember) = $event))
                    }, null, 8, ["value", "modelValue"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                class: "!tw-w-auto sm:!tw-w-full tw-max-w-full sm:tw-gap-2 button",
                label: "ADD NEW MEMBER",
                variant: "secondary",
                onClick: $setup.onClickAddMemberButton
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                label: "SEND INVITE",
                variant: "accent",
                isActive: $setup.selectedMember.length,
                onClick: $setup.onClickSendInviteButton,
                class: "button !tw-w-auto sm:!tw-w-full tw-max-w-full sm:tw-mt-6"
              }, null, 8, ["isActive", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowTeamMemberModal)
      ? (_openBlock(), _createBlock(_component_TeamMemberModal, {
          key: 1,
          onOnClickCloseTab: $setup.onClickCloseTeamModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowInvitedModal)
      ? (_openBlock(), _createBlock(_component_GeneralDialog, {
          key: 2,
          onOnClose: $setup.onClickCloseButton
        }, {
          body: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedMember, (member, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                class: "tw-mt-4 tw-text-xs tw-font-bold tw-text-[#0c0f4a] tw-tracking-[0.14px]"
              }, _toDisplayString(member), 1))
            }), 128))
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: $setup.onClickCloseButton,
              class: "button button-purple-border"
            }, {
              default: _withCtx(() => [
                _createTextVNode("CLOSE")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowUpgradePremiumModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerSubscriptionModal, {
          key: 3,
          onCloseSubscriptionModal: $setup.closeUpgradePremiumModal,
          onCloseSelectWorkstationTypeModal: $setup.closeUpgradePremiumModal
        }, null, 8, ["onCloseSubscriptionModal", "onCloseSelectWorkstationTypeModal"]))
      : _createCommentVNode("", true)
  ], 64))
}